export const contractorsStoreKey = 'contractors';
